export const APPLICATION_NAME = "react-app";
export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+-])[A-Za-z\d@$!%*#?&+-]{8,}$/;

export const TOKEN_KEY = "tokendata";
